"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 共享包入口
 * -----------------------------------------------------------------------------
 * 跨端共享的单一来源：
 *   constants  枚举与常量（与 prisma/schema.prisma 保持一致）
 *   money      金额工具（分为单位）
 *   mask       脱敏工具（日志与响应必须使用；**只覆盖身份证 / 手机号 / 银行卡，姓名不在其列**）
 *   errors     错误码常量
 *   permissions 权限码常量
 *   audit      审计动作码常量
 *   form-validator 表单提交值校验（三端同一份判定逻辑）
 *   region     行政区划（省 / 市 / 区三级）码表与查询逻辑（邮寄地址区域匹配的单一来源）
 *
 * 约束：三端（server / admin / h5）引用同一份类型与规则，不得各写一套。
 */
__exportStar(require("./audit.js"), exports);
__exportStar(require("./constants.js"), exports);
__exportStar(require("./data/regions.js"), exports);
__exportStar(require("./errors.js"), exports);
__exportStar(require("./form-schema.js"), exports);
__exportStar(require("./form-validator.js"), exports);
__exportStar(require("./mask.js"), exports);
__exportStar(require("./money.js"), exports);
__exportStar(require("./permissions.js"), exports);
__exportStar(require("./region.js"), exports);
//# sourceMappingURL=index.js.map